import { Page, PageHeader } from '@indipia/ui-core'
import type { NavFn } from '../pages/SchedulerPage'
import { ForemanConfirmSettingSection } from '../components/ForemanConfirmSettingSection'

type Props = { navigate: NavFn }

// 시공파트너 일정확인 알림설정 (기획서 H-7) — 변경 즉시 저장·초기화는 섹션이 처리.
export function ForemanConfirmSettingsView({ navigate: _navigate }: Props) {
  return (
    <div style={{ minHeight: '100%' }}>
      <Page width="md">
        <PageHeader
          title="시공파트너 일정확인 알림설정"
          subtitle="반장님께 보내는 일정확인 알림 요청의 답장 기한과 다음 반장님 자동 발송 규칙을 설정하세요"
        />
        <ForemanConfirmSettingSection />
      </Page>
    </div>
  )
}
